// Slow editorial marquee to break the rhythm between sections.
export default function Marquee({
  items = [],
  dark = false,
  testId = "marquee",
}) {
  const content = [...items, ...items];
  return (
    <div
      data-testid={testId}
      className={`overflow-hidden border-y py-6 md:py-8 select-none ${
        dark
          ? "bg-[#111111] border-[#faf8f5]/15 text-[#faf8f5]"
          : "bg-[#f1ede7] border-[#111111]/10 text-[#111111]"
      }`}
    >
      <div className="marquee-track">
        {content.map((it, i) => (
          <span
            key={i}
            className="font-display italic text-2xl md:text-4xl tracking-tight px-6 md:px-10 flex items-center gap-6 md:gap-10"
          >
            {it}
            <span className="text-[#a89f8e] not-italic font-body text-xl">✕</span>
          </span>
        ))}
      </div>
    </div>
  );
}
